import type { ReactElement } from "react";
import { useTranslation } from "react-i18next";
import type { LaborCostChartMode } from "@/pages/human-resources/time-management/business/analysis/LaborCostChartMode.ts";
import ToggleButton from "@/shared/components/generic/button/toggle-button/ToggleButton.tsx";
import ToggleButtonGroup from "@/shared/components/generic/button/toggle-button/ToggleButtonGroup.tsx";
import "./SwitchLaborCostMode.scss";

interface Props {
  mode: LaborCostChartMode;
  onChange: (value: LaborCostChartMode) => void;
}

export default function SwitchLaborCostMode({
  mode,
  onChange,
}: Props): ReactElement {
  const { t } = useTranslation("humanResources");

  return (
    <div className="switch-labor-cost-mode">
      <ToggleButtonGroup direction="horizontal">
        <ToggleButton
          text={t("humanResources:common.section", { count: 1 })}
          selected={mode === "SECTION"}
          onClick={() => {
            onChange("SECTION");
          }}
          outlined={false}
        />
        <ToggleButton
          text={t("humanResources:common.role", { count: 1 })}
          selected={mode === "ROLE"}
          onClick={() => {
            onChange("ROLE");
          }}
          outlined={false}
        />
      </ToggleButtonGroup>
    </div>
  );
}
